<template>
  <div class="device">
<!--    新增IDC-->
    <el-dialog
      :title="dialogTitle"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="70%">
      <el-form label-position="left" style="margin-left: 20px" :model="formData" ref="formData" :rules="rules" label-width="140px">
        <el-form-item prop="name" label="IDC名称" >
          <el-input v-model="formData.name" placeholder="请输入内容" style="width: 250px" ></el-input>
        </el-form-item>
        <el-form-item prop="area" label="区域">
          <el-select v-model="formData.area" @change="getAreaSelect(1)" filterable  placeholder="请选择洲"
                     style="width: 120px;margin-right: 10px;">
            <el-option v-for="(option, idx) in areainfo0"
                       :key="idx"
                       :label="option.domainName"
                       :value="option.aCode"></el-option>
          </el-select>
          <el-select v-if="areainfoVisible1" v-model="formData.country" filterable @change="getAreaSelect(2)" placeholder="请选择国家"
                     style="width: 120px;margin-right: 10px;">
            <el-option v-for="(option, idx) in areainfo1"
                       :key="idx"
                       :label="option.domainName"
                       :value="option.aCode"></el-option>
          </el-select>
          <el-select v-if="areainfoVisible2" v-model="formData.province" filterable @change="getAreaSelect(3)" placeholder="请选择省市"
                     style="width: 120px;margin-right: 10px;">
            <el-option v-for="(option, idx) in areainfo2"
                       :key="idx"
                       :label="option.domainName"
                       :value="option.aCode"></el-option>
          </el-select>

          <el-select v-if="areainfoVisible3" v-model="formData.city" filterable @change="getAreaSelect(4)" placeholder="请选择城市"
                     style="width: 120px;margin-right: 10px;">
            <el-option v-for="(option, idx) in areainfo3"
                       :key="idx"
                       :label="option.domainName"
                       :value="option.aCode"></el-option>
          </el-select>
          <el-select v-if="areainfoVisible4" v-model="formData.county" filterable placeholder="请选择区县" style="width: 120px;margin-right: 10px;">
            <el-option v-for="(option, idx) in areainfo4"
                       :key="idx"
                       :label="option.domainName"
                       :value="option.aCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="inEnterpriseIdc" label="是否私有下沉机房">
          <el-radio-group v-model="formData.inEnterpriseIdc">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="formData.remark" placeholder="请输入内容" style="width: 250px"></el-input>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="saveIdc()">提 交</el-button>
          <el-button @click="resetForm(false)">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "IdcEdit",
    data() {
      return {
        formData: {
          remark: "",
          name: "",
          area: "",
          country: "",
          province: "",
          city: "",
          county: "",
          domainId: "",
          inEnterpriseIdc:false
        },
        areainfo0: [],
        areainfo1: [],
        areainfo2: [],
        areainfo3: [],
        areainfo4: [],
        dialogTitle: '新增IDC',
        areainfoVisible1: false,
        areainfoVisible2: false,
        areainfoVisible3: false,
        areainfoVisible4: false,
        rules: {
          name: [{required: true, message: '必填项'}],
          inEnterpriseIdc: [{required: true, message: '必填项'}]
        },
      }
    },
    methods: {
      resetForm(val) {
        this.$emit('editCallback', val)
      },
      saveIdc() {
        let _domainId = ""
        if(this.formData.area){
          _domainId = this.formData.area
        }
        if(this.formData.country){
          _domainId = this.formData.country
        }
        if(this.formData.province){
          _domainId = this.formData.province
        }
        if(this.formData.city){
          _domainId = this.formData.city
        }
        if(this.formData.county){
          _domainId = this.formData.county
        }
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55,55,0.4)'
        });
        let data = {
          remark: this.formData.remark,
          idcName: this.formData.name,
          domainId: _domainId,
          id: this.id,
          inEnterpriseIdc:this.formData.inEnterpriseIdc
        }
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/idc/update', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.resetForm(true);
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              loading.close();
            }, 1000);
          })
      },
      getArea(level,pid) {
        let _this = this;
        let data = {
          parentACode: pid
        };
        this.$axios.post(this.baseUrl3 + 'management3/area/areainfo', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (level == 0) {
                _this.areainfo0 = data;
              } else if (level == 1) {
                _this.areainfo1 = data;
              } else if (level == 2) {
                _this.areainfo2 = data;
              } else if (level == 3) {
                _this.areainfo3 = data;
              } else if (level == 4) {
                _this.areainfo4 = data;
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getAreaSelect(level) {
        let _this = this;
        let pid = null;
        if (level == 0) {
          pid = pid;
        } else if (level == 1) {
          pid = _this.formData.area;
          _this.areainfoVisible1 = true;
          _this.formData.country = "";
          _this.formData.province = "";
          _this.formData.city = "";
          _this.formData.county = "";
        } else if (level == 2) {
          pid = _this.formData.country;
          _this.areainfoVisible2 = true;
          _this.formData.province = "";
          _this.formData.city = "";
          _this.formData.county = "";
        } else if (level == 3) {
          pid = _this.formData.province;
          _this.areainfoVisible3 = true;
          _this.formData.city = "";
          _this.formData.county = "";
        } else if (level == 4) {
          pid = _this.formData.city;
          _this.areainfoVisible4 = true;
          _this.formData.county = "";
        }
        let data = {
          parentACode: pid
        };
        this.$axios.post(this.baseUrl3 + 'management3/area/areainfo', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (level == 0) {
                _this.areainfo0 = data;
              } else if (level == 1) {
                _this.areainfo1 = data;
              } else if (level == 2) {
                _this.areainfo2 = data;
              } else if (level == 3) {
                _this.areainfo3 = data;
              } else if (level == 4) {
                _this.areainfo4 = data;
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initIdcInfo() {
        let data = {
          id: this.id
        }
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/idc/idcinfo', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.formData.remark = data.remark;
              _this.formData.name = data.idcName;
              _this.formData.area = data.areaAllInfo.didContinent;
              _this.formData.country = data.areaAllInfo.didCountry;
              _this.formData.province = data.areaAllInfo.didProvince;
              _this.formData.city = data.areaAllInfo.didCity;
              _this.formData.county = data.areaAllInfo.didDistricts;
              _this.formData.inEnterpriseIdc = data.inEnterpriseIdc;
              //_this.getArea(0,null);
              if(_this.formData.area){
                _this.getArea(1,_this.formData.area);
                _this.areainfoVisible1 = true;
              }
              if(_this.formData.country){
                _this.getArea(2,_this.formData.country);
                _this.areainfoVisible2 = true;
              }
              if(_this.formData.province){
                _this.getArea(3,_this.formData.province);
                _this.areainfoVisible3 = true;
              }
              if(_this.formData.city){
                _this.getArea(4,_this.formData.city);
                _this.areainfoVisible4 = true;
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    props: {
      visible: {
        type: Boolean
      },
      id: {
        type: Number
      }
    },
    created() {
      // this.getArea(1,"0000");
      this.getArea(0,null);
      if (this.id) {
        this.dialogTitle = '编辑IDC';
        this.initIdcInfo();
      }
    },
  }
</script>

<style>
  .el-loading-spinner {
    background-image:url('../../assets/loading1.svg');
    background-size:63px 100px;
    background-repeat: no-repeat;
    height:30%;
    background-position:center;
    top:200px;
  }
  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
</style>
